export default __webpack_public_path__ + "static/media/EsilioPic6.005a3738.png";